import { Base } from 'src/api/Base'

export class MarketShareAPI extends Base {
  static get entity() {
    return 'market-share'
  }

  static async init({ year, month }) {
    const params = {
      ...this.datepicker,
    }

    const body = {
      year,
      month,
    }

    const { data } = await this.request().post(`/${this.entity}/init`, body, {
      params,
    })

    return data
  }

  static async getZipCodes({ radius }) {
    const params = {
      radius,
      ...this.datepicker,
    }

    const { data } = await this.request().get(`/${this.entity}/zipcodes`, {
      params,
    })

    return data
  }

  static async getData() {
    const params = {
      ...this.datepicker,
    }

    const { data } = await this.request().get(`/${this.entity}/data`, {
      params,
    })

    return data
  }

  static async reportUpload({ onUploadProgress, file, dealerShipId }) {
    const formData = new FormData()
    formData.append('uploadedFile', file)

    const { year, month } = this.datepicker
    const params = {
      year,
      month,
      dealerShipId,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/report-upload`, formData, {
      params,
      onUploadProgress,
    })

    return data
  }

  static async reportRemove({ fileId }) {
    const body = {
      fileId,
    }

    const { data } = this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/report-remove`, body)

    return data
  }

  static async update({ value, competitorId }) {
    const params = {
      competitorId,
      ...this.datepicker,
    }
    const body = {
      value,
    }
    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(`/${this.entity}/update`, body, {
      params,
    })

    return data
  }

  static async delete({ competitorId }) {
    const params = {
      competitorId,
      ...this.datepicker,
    }

    const { data } = await this.request({
      shouldCancelOnRoute: false,
      shouldCancelOnGet: false,
    }).post(
      `/${this.entity}/delete`,
      {},
      {
        params,
      }
    )

    return data
  }
}
